export default __webpack_public_path__ + "static/media/ic_con_call.142bd13d.svg";